import React, { Component } from "react";
import { Modal, Button, Form, Col, Image, Alert } from "react-bootstrap";
import { register } from "../Services";
import { toast } from "react-toastify";
import { getHash } from "./commons/Functions";

class Register extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      modalShowErr: false,
      modalErrMsg: "Entered email already exist!!!",
    };
    this.baseState = this.state;
  }

  componentWillUnmount() {
    this.setState(this.baseState);
  }

  handleChange = (type) => (event) => {
    let value = event;
    if (event.target) {
      value = event.target.value;
    }
    this.setState({ [type]: value });
  };

  handleSubmit = (event) => {
    this.setState({ modalShowErr: false });
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      var body = {
        ...this.state,
        password: getHash(this.state.password),
        email: this.state.email.toLowerCase(),
        userRole: "customer",
      };
      if (this.state.password !== this.state.cPassword) {
        toast.error("Password doesn't match !");
      } else {
        register(body)
          .then((res) => {
            toast.success("Account created, Please confirm your email !");
            this.loginClick();
          })
          .catch((err) => {
            if (err.then && typeof err.then === "function") {
              err.then((e) => {
                toast.error("Unable to register the new user");
                if (e.exist) {
                  this.setState({ modalShowErr: true });
                }
              });
            } else {
              console.log(err);
            }
          });
      }
    }
    event.preventDefault();
    event.stopPropagation();
  };

  loginClick = () => {
    this.props.handleClose();
    this.props.handleLoginShow();
  };

  render() {
    return (
      <Modal
        show={this.props.showRegister}
        onHide={this.props.handleClose}
        centered
        dialogClassName="wide-modal"
      >
        <Form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title className="w-100 text-center">
              Create Account
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex flex-column align-items-center mb-3">
              <Image
                src={require("../images/login.png")}
                width="80"
                roundedCircle
                className="mb-3"
                alt="Register"
              />
            </div>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridFName">
                <Form.Label>First name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter first name"
                  onChange={this.handleChange("fname")}
                  size="sm"
                  autoComplete="off"
                  style={{ marginBottom: 10 }}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridLName">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter last name"
                  onChange={this.handleChange("lname")}
                  size="sm"
                  autoComplete="off"
                  style={{ marginBottom: 10 }}
                />
              </Form.Group>
            </Form.Row>
            <Form.Group controlId="formGridPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Enter Phone Number"
                onChange={this.handleChange("phone")}
                size="sm"
                autoComplete="off"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            <Form.Group controlId="formGridNIC">
              <Form.Label>NIC</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter NIC (Optional)"
                onChange={this.handleChange("nic")}
                size="sm"
                autoComplete="off"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            <Form.Group controlId="controlTextarea1">
              <Form.Label>Address</Form.Label>
              <Form.Control
                required
                as="textarea"
                rows="1"
                onChange={this.handleChange("address")}
                size="sm"
                autoComplete="off"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            <Form.Group controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="Enter email"
                onChange={this.handleChange("email")}
                size="sm"
                autoComplete="off"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Enter Password"
                onChange={this.handleChange("password")}
                size="sm"
                autoComplete="new-password"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            <Form.Group controlId="formBasicCoPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Confirm Password"
                onChange={this.handleChange("cPassword")}
                size="sm"
                autoComplete="new-password"
                style={{ marginBottom: 10 }}
              />
            </Form.Group>
            {this.state.modalShowErr && (
              <Alert variant="danger">{this.state.modalErrMsg}</Alert>
            )}
            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-2"
              size="sm"
            >
              Create account
            </Button>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            <span>Already have an account?</span>
            <Button
              variant="outline-primary"
              className="ml-2"
              onClick={this.loginClick}
              size="sm"
            >
              Sign in
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default Register;
